module.exports = __webpack_public_path__ + "img/orange-gift.dfe4b580.png";